import React from 'react'
import SectionDivider from '../SectionDivider'
import Input from '../../Input'
import useTransformFieldProperties from '../../hooks/useTransformFieldProperties'
import useTransformMultipleFieldsProperties from '../../hooks/useTransformMultipleFieldsProperties'

const InputField = ({ id, page, position, label, text, dimension }) => {
  const generateProperties = useTransformFieldProperties({ id, page, position, dimension })
  return (
    <Input
      classes="dimension"
      prepend={<span className="dome-p2 dome-color-lite-grey">{text}</span>}
      label={label}
      {...generateProperties()}
    />
  )
}

const InputFieldForGroup = ({ ids, page, position, label, text, dimension, components }) => {
  const generateProperties = useTransformMultipleFieldsProperties({ ids, page, position, dimension, components })
  return (
    <Input
      classes="dimension"
      prepend={<span className="dome-p2 dome-color-lite-grey">{text}</span>}
      label={label}
      {...generateProperties()}
    />
  )
}

export const TransfromGroupFields = ({ ids, components, page, sectionName = 'transform' }) => {
  return (
    <SectionDivider sectionName={sectionName}>
      <div className="split-input">
        <InputFieldForGroup ids={ids} page={page} components={components} dimension="x" text="x" label="position" />
        <InputFieldForGroup ids={ids} page={page} components={components} dimension="y" text="y" />
      </div>
      <div className="split-input">
        <InputFieldForGroup ids={ids} page={page} components={components} dimension="width" text="w" label="size" />
        <InputFieldForGroup ids={ids} page={page} components={components} dimension="height" text="h" />
      </div>
    </SectionDivider>
  )
}

const Transform = ({ id, page, position, sectionName = 'transform', actionName, onAction }) => {
  return (
    <SectionDivider sectionName={sectionName} actionName={actionName} onAction={onAction}>
      <div className="split-input">
        <InputField id={id} page={page} position={position} dimension="x" text="x" label="position" />
        <InputField id={id} page={page} position={position} dimension="y" text="y" />
      </div>
      <div className="split-input">
        <InputField id={id} page={page} position={position} dimension="width" text="w" label="size" />
        <InputField id={id} page={page} position={position} dimension="height" text="h" />
      </div>
    </SectionDivider>
  )
}

export default Transform
